module.exports = __webpack_public_path__ + "img/guerrico.133a917f.png";